import { useAtomValue } from 'jotai';

import { activeData3dAtom, comparisonData3dAtom, currentFrameAtom, syncedFrameAtom } from '@store';

import { MemoPaths } from '../visualizations/Paths';

const CURRENT = 'current';

export const Paths = ({ origin = CURRENT }) => {
    const currentFrame = useAtomValue(origin === CURRENT ? currentFrameAtom : syncedFrameAtom);
    const data = useAtomValue(origin === CURRENT ? activeData3dAtom : comparisonData3dAtom);
    if (!data) return null;
    return (
        <MemoPaths
            frame={currentFrame}
            skeleton={data.skeleton}
            keypointIdToName={data.keypointIdToName}
            segmentation={data.segmentation}
            clubTrack={data.clubTrack}
        />
    );
};
